import { useEffect, useState } from "react";
import { api } from "../../api";
import { Btn, Card, Badge, Input, PageHead } from "../../components/ui";
import Icon from "../../components/Icon";

function Row({ r, onDecide }) {
  const [date, setDate] = useState(r.assigned_date || r.requested_date || "");
  const [link, setLink] = useState(r.meeting_link || "");
  return (
    <Card className="p-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <div className="font-medium text-slate-900">{r.student_name} <span className="text-slate-400 text-sm">· {r.student_email}</span></div>
          <div className="text-sm text-slate-500">Requested a {r.milestone}% interactive session · preferred {r.requested_date || "—"}</div>
        </div>
        <Badge>{r.status}</Badge>
      </div>
      <div className="grid sm:grid-cols-2 gap-3 mt-4">
        <div><span className="block text-xs text-slate-500 mb-1">Assigned date</span><Input type="date" value={date} onChange={(e) => setDate(e.target.value)} /></div>
        <div><span className="block text-xs text-slate-500 mb-1">Live session link</span><Input value={link} onChange={(e) => setLink(e.target.value)} placeholder="https://zoom.us/j/…" /></div>
      </div>
      <div className="flex justify-end gap-2 mt-4">
        <Btn variant="outline" onClick={() => onDecide(r.id, { assigned_date: date, meeting_link: link, action: "reassign" })}>Reassign date</Btn>
        <Btn onClick={() => onDecide(r.id, { assigned_date: date, meeting_link: link, action: "approve" })}>Approve & send link</Btn>
      </div>
    </Card>
  );
}

export default function Notifications({ toast, onOpenStudent }) {
  const [reqs, setReqs] = useState([]);
  const [certReqs, setCertReqs] = useState([]);
  const load = () => {
    api.adminSessions().then(setReqs).catch(() => {});
    api.certRequests().then(setCertReqs).catch(() => {});
  };
  useEffect(() => { load(); }, []);
  const dismissCert = async (id) => { try { await api.dismissCertRequest(id); load(); } catch (e) { toast && toast(e.message); } };
  const decide = async (id, body) => {
    await api.decideSession(id, body);
    toast(body.action === "reassign" ? "Date reassigned & link sent" : "Session approved & link sent");
    load();
  };
  const pending = reqs.filter((r) => r.status === "Requested");
  return (
    <div>
      <PageHead title="Notifications" sub="Requests and alerts that need a decision." />
      {certReqs.length > 0 && (
        <div className="mb-6">
          <div className="text-sm font-semibold text-slate-700 mb-2">Additional certificate requests</div>
          <div className="space-y-3">
            {certReqs.map((cr) => (
              <Card key={cr.id} className="p-4">
                <div className="flex flex-wrap items-center justify-between gap-3">
                  <div>
                    <div className="font-medium text-slate-900">{cr.name} <span className="text-slate-400 text-sm">· {cr.phone || "no phone"}</span></div>
                    <div className="text-sm text-slate-500">Requested an additional certificate{cr.note ? ` — "${cr.note}"` : ""}</div>
                  </div>
                  <div className="flex gap-2">
                    <Btn onClick={() => onOpenStudent && onOpenStudent(cr.student_id)}>Open student</Btn>
                    <Btn variant="outline" onClick={() => dismissCert(cr.id)}>Dismiss</Btn>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>
      )}
      {pending.length === 0 && reqs.length === 0 && certReqs.length === 0 && (
        <Card className="p-8 text-center text-slate-400"><Icon name="bell" size={22} className="mx-auto mb-2" />Nothing needs your attention right now.</Card>
      )}
      <div className="space-y-3">
        {reqs.map((r) => <Row key={r.id} r={r} onDecide={decide} />)}
      </div>
    </div>
  );
}
